import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { oktaAuth } from "../auth/okta.js";

export default function LoginCallback() {
  const [ok, setOk] = useState(null);

  useEffect(() => {
    oktaAuth
      .handleLoginRedirect()
      .then(() => setOk(true))
      .catch(() => setOk(false));
  }, []);

  if (ok === false) return <div className="error">Login failed</div>;
  if (ok === null) return <p>Signing in…</p>;
  return <Navigate to="/" replace />;
}
